module.exports = __webpack_public_path__ + "img/icon_5_66.9ef8bd7f.png";